"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _config = _interopRequireDefault(require("./config"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Row = _styledComponents["default"].div.withConfig({
  displayName: "Row",
  componentId: "lv46kk-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  display: flex;\n  flex: 0 1 auto;\n  flex-direction: row;\n  flex-wrap: wrap;\n  margin-right: ", "rem;\n  margin-left: ", "rem;\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), function (p) {
  return (0, _config["default"])(p).gutterWidth / 2 * -1;
}, function (p) {
  return (0, _config["default"])(p).gutterWidth / 2 * -1;
}, function (p) {
  return p.reverse && "\n    flex-direction: row-reverse;\n  ";
}, function (p) {
  return p.start && (0, _config["default"])(p).media[p.start](_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    justify-content: flex-start;\n  "])));
}, function (p) {
  return p.center && (0, _config["default"])(p).media[p.center](_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    justify-content: center;\n  "])));
}, function (p) {
  return p.end && (0, _config["default"])(p).media[p.end](_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    justify-content: flex-end;\n  "])));
}, function (p) {
  return p.top && (0, _config["default"])(p).media[p.top](_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    align-items: flex-start;\n  "])));
}, function (p) {
  return p.middle && (0, _config["default"])(p).media[p.middle](_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    align-items: center;\n  "])));
}, function (p) {
  return p.bottom && (0, _config["default"])(p).media[p.bottom](_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    align-items: flex-end;\n  "])));
}, function (p) {
  return p.around && (0, _config["default"])(p).media[p.around](_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n    justify-content: space-around;\n  "])));
}, function (p) {
  return p.between && (0, _config["default"])(p).media[p.between](_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n    justify-content: space-between;\n  "])));
}, function (p) {
  return p.first && (0, _config["default"])(p).media[p.first](_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n    order: -1;\n  "])));
}, function (p) {
  return p.last && (0, _config["default"])(p).media[p.last](_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n    order: 1;\n  "])));
});

Row.displayName = 'Row';
var _default = Row;
exports["default"] = _default;